<template>
  <div class="text-center">
    <h5 class="mb-3">Paso 2: Confirma con un código</h5>
    <p class="text-muted mb-4">
      Ingresa el código de 6 dígitos de tu aplicación autenticadora:
    </p>

    <div class="form-group">
      <input 
        :value="code"
        @input="handleInput"
        type="text" 
        maxlength="6"
        placeholder="123456"
        class="form-control form-control-lg text-center two-factor-code-input"
        style="max-width: 200px; margin: 0 auto;"
        :disabled="loading"
      />
    </div>

    <!-- Actions -->
    <div class="mt-4 d-flex justify-content-between">
      <button 
        @click="$emit('back')" 
        class="btn btn-secondary"
        :disabled="loading"
      >
        <i class="ri-arrow-left-line mr-1"></i>
        Volver
      </button>
      <button 
        @click="$emit('confirm')" 
        class="btn btn-success"
        :disabled="loading || code.length !== 6"
      >
        <span v-if="loading">
          <i class="mdi mdi-spin mdi-loading mr-1"></i>
          {{ loadingText }}
        </span>
        <span v-else>
          <i class="ri-check-line mr-1"></i>
          {{ confirmText }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TwoFactorVerificationStep',
  props: {
    code: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: 'Confirmar y activar'
    },
    loadingText: {
      type: String,
      default: 'Verificando...'
    }
  },
  emits: ['update:code', 'back', 'confirm'],
  methods: {
    handleInput(event) {
      const value = event.target.value.replace(/\D/g, '').slice(0, 6);
      this.$emit('update:code', value);
    }
  }
};
</script> 